import { render, staticRenderFns } from "./AddOrderLinesModalFrame.vue?vue&type=template&id=148242b2&scoped=true&"
import script from "./AddOrderLinesModalFrame.vue?vue&type=script&lang=js&"
export * from "./AddOrderLinesModalFrame.vue?vue&type=script&lang=js&"
import style0 from "./AddOrderLinesModalFrame.vue?vue&type=style&index=0&id=148242b2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148242b2",
  null
  
)

export default component.exports